module.exports = __webpack_public_path__ + "static/img/hero.7bccd7f5.webp";